import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/assets/icons/banner-img.png");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/assets/icons/done.svg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/assets/icons/left-arrow-circle.svg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/ApolloNextAppProvider.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/hooks.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/atoms/EnrollButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/atoms/EnrollNowSponsoredCertifications/EnrollNowSponsoredCertifications.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/atoms/SideButtons/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/common/Analytics/CustomButton.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/BannerWithImage/BannerWithImage.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/BannerWithImageNew/BannerWithImageNew.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/BlogDetailsNewWrapper/ContentBody/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/Carousels/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/Carousels/HeroCarousel/ClientSideButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/CertCard/ClientButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/CourseStructureSection/CourseStructureSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/DegreeOfferedCarousel/DegreeOfferedCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/DegreeProgramCard/DegreeProgramCard.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/FireWebEngageEvents/FireWebEngageEvents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/Forms/TempleteOneConnectModalForm/TemplateOneConnectModalForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HightlightsCard","default"] */ "/home/ubuntu/frontend/src/components/molecules/HighlightsCarousel/HighlightsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/KpmgAccordion/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/LandingPageBanner/LandingPageBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/LandingPageBannerCarousel/LandingPageBannerCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/LandingPageHeader/LandingPageHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/Referral/CheckStatus/Login/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/Referral/Common/ReferralHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/Referral/DashBoard/dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/Referral/ReferandEarn/ReferralAdvantage/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/Referral/ReferandEarn/ReferralBanner/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/Referral/ReferandEarn/ReferralForm/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/Referral/ReferandEarn/ReferralTnC/index.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/CertCard/CertCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SocialMediaSection/SocialMediaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/SpecializationCard/SpecializationCard.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SponsoredCertification/BannerSection.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SkillGainSection/SkillGainSection.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/CertOverview/CertOverview.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SponsoredCertification/EarnAndShareCertificateSection/EarnAndShareCertificate.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SponsoredCertification/FaculitySection/FaculitySection.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/AmityOnlineAdvantage/AmityOnlineAdvantage.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/CertificationCarouselSlide/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/AdvantageCard/AdvantageCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SectionCard/SectionCard.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/SponsoredCertification/StripTextUI/StripTextUI.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/ToolsPlatformCovered/ToolsPlatform.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/CampusEmersionCarousel/CampusEmersionCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/DegreeProgramsSection/DegreeProgramsSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/DigitalMarketing/DigitalMarketing.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/IndustryInsightsCard/IndustryInsightsCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/atoms/StripDataMoveable/StripDataMoveable.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/FacultyWithDescription/FacultyWithDescription.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/HeaderOpt/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/IndustryInsightsSection/IndustryInsightsWithDesc.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/PodcastSection/PodcastSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/SimilarProgramsSection/ProgramList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/SimilarProgramsSection/SimilarProgramsSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/StudentTestimonials/StudentTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/VideoTestimonialWithDesc/VideoTestimonialWithDesc.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/pages/referral/index.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/pages/SponsoredCertifications/SponsoredCertification.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/sections/AccreditionsRecognitions/ClientWrapperIntersectionObserver.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/Breadcrumbs/BreadCrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/sections/BuildNation/BuildNation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/sections/FacultyCarousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/sections/NewLists/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/PagesCards/PagesCards.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/ProgramHightlights/ProgramHighlights.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/FaqSection/Faq.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/BannerCard/BannerCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/CertificiationProgramSection/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/sections/WhyAmityCard/WhyAmityItemClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/templates/Faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/templates/LpStudentTestimonial/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/helpers/ShowImageOnViewPort.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/LpRevamp/LpBanner/LpBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/molecules/PageCard2/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/molecules/SectionCard2/SectionCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/AdmissionCard/AdmissionCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/atoms/ListWithDoneIcon/ListWithDoneIcon.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/EligibiltyCriteriaSection/EligibilityCriteriaSection.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/LearningOutcomeCard/LearningOutcome.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/StripData/StripData.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/organisms/AnnouncementSection/AnnoucementSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/BlogLeadForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/BrandWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/CourseCurriculum/ClientSideButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/FacultyCarousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/organisms/FaqWithCategory/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/organisms/FeesSection/FeesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/HeadingWithBullets/HeadingWithBullets.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/HolisticCareerServicesSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/JourneryForGraduationSec/JourneyForGraduationContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/LeadForm/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/organisms/OverviewSection/OverviewSection.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/molecules/AdvantageCard/AdvantageCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/organisms/ProgramHightlights/ProgramHighlights.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/organisms/CourseCurriculum/CourseCurriculum.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/organisms/JourneryForGraduationSec/JourneyForGraduation.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/molecules/SectionCard/SectionCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/CareerServices/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/JobRolesCard/JobRolesCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/JobRolesSection/JobRolesSection.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/BrandLogos/Brandlogo.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/molecules/SectionCardWithBg/SectionCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/Faculties/Faculties.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/FaqSection/FaqSection.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/WhyAmityCard/WhyAmity.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/DegreeProgram/style.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/NewsStories/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/FeaturesSection/FeaturesSection.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/ProgramSpecializationSection/ProgramSpecialization.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/LeadingResearchCard/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/LeadingResearchSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/AccreditionsRecognitions/AccreditionsRecognitions.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/templates/CampLandingTemplate1/camplanding.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/ContactUsSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/ProgramEligibilityDetails/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/atoms/BulletsMarkdown/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/ProgramFeesDetails/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/SemesterFeesSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/templates/ProgramDetailsSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SpecializationsWIthinProgram/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/SimilarBlogsSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/TagsAndSocialMediaSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/BlogDetailsNewWrapper/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/LandingPageFooter/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/atoms/Loader/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/organisms/SecondaryMenu/SecondaryMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/SimilarProgramSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/sections/BannerCard/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/StudentTestimonial/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp2/molecules/PageCardImmersion/index.tsx");
